module.exports = "<div class=\"host-title mat-body2\">\n    <ng-content></ng-content>\n</div>\n<div class=\"host-ripple\" mat-ripple></div>"